import {
  Box,
  Typography,
  Paper,
  TextField,
  MenuItem,
  Button,
} from "@mui/material";

import { useState } from "react";

import { DASHBOARD_STRINGS } from "../../constants/strings";

import "./filterBar.css";

interface Props {
  filters: {
    from: string;
    to: string;
    product: string;
    status: string;
  };

  setFilters: (filters: any) => void;

  onReset: () => void;
}

const DashboardFilter: React.FC<Props> = ({
  filters,
  setFilters,
  onReset,
}) => {
  const [quickFilter, setQuickFilter] =
    useState<string>("");

  // ================= DATE FORMAT =================

  const formatDate = (date: Date) => {
    const offset =
      date.getTimezoneOffset();

    const localDate = new Date(
      date.getTime() -
        offset * 60000,
    );

    return localDate
      .toISOString()
      .split("T")[0];
  };

  // ================= QUICK FILTER =================

  const handleQuickFilter = (
    type: string,
  ) => {
    setQuickFilter(type);

    const today = new Date();

    let from = "";

    let to = formatDate(today);

    if (type === "today") {
      from = formatDate(today);
    }

    if (type === "week") {
      const d = new Date();

      d.setDate(
        today.getDate() - 7,
      );

      from = formatDate(d);
    }

    if (type === "month") {
      const d = new Date(
        today.getFullYear(),
        today.getMonth(),
        1,
      );

      from = formatDate(d);
    }

    if (type === "year") {
      const d = new Date(
        today.getFullYear(),
        0,
        1,
      );

      from = formatDate(d);
    }

    setFilters({
      ...filters,
      from,
      to,
    });
  };

  return (
    <Paper className="dashboard-filter">
      <Typography className="filter-title">
        {
          DASHBOARD_STRINGS.FILTERS
        }
      </Typography>

      {/* MAIN ROW */}

      <Box
        className="filter-row"
        sx={{
          mt: 1,

          display: "flex",

          justifyContent:
            "space-between",

          alignItems: "center",

          gap: 2,

          flexWrap: "wrap",
        }}
      >
        {/* LEFT FILTERS */}

        <Box
          sx={{
            display: "flex",
            gap: 1,
            flexWrap: "wrap",
          }}
        >
          {/* START DATE */}

          <TextField
            label="Start Date"
            type="date"
            size="small"
            value={filters.from}
            onChange={(e) =>
              setFilters({
                ...filters,
                from:
                  e.target.value,
              })
            }
            className="filter-input small"
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
          />

          {/* END DATE */}

          <TextField
            label="End Date"
            type="date"
            size="small"
            value={filters.to}
            onChange={(e) =>
              setFilters({
                ...filters,
                to:
                  e.target.value,
              })
            }
            className="filter-input small"
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
          />

          {/* PRODUCT */}

          <TextField
            select
            size="small"
            value={
              filters.product || ""
            }
            onChange={(e) =>
              setFilters({
                ...filters,
                product:
                  e.target.value,
              })
            }
            className="filter-input small"
            slotProps={{
              select: {
                displayEmpty: true,
              },
            }}
          >
            <MenuItem value="">
              All Products
            </MenuItem>

            <MenuItem value="car">
              Car
            </MenuItem>

            <MenuItem value="cv">
              CV
            </MenuItem>

            <MenuItem value="ce">
              CE
            </MenuItem>

            <MenuItem value="tractor">
              Tractor
            </MenuItem>

            <MenuItem value="other">
              Other
            </MenuItem>
          </TextField>

          {/* STATUS */}

          <TextField
            select
            size="small"
            value={
              filters.status || ""
            }
            onChange={(e) =>
              setFilters({
                ...filters,
                status:
                  e.target.value,
              })
            }
            className="filter-input small"
            slotProps={{
              select: {
                displayEmpty: true,
              },
            }}
          >
            <MenuItem value="">
              All Status
            </MenuItem>

            <MenuItem value="login">
              Login
            </MenuItem>

            <MenuItem value="pending">
              Pending
            </MenuItem>

            <MenuItem value="credit">
              Credit
            </MenuItem>

            <MenuItem value="approved">
              Approved
            </MenuItem>

            <MenuItem value="disbursed">
              Disbursed
            </MenuItem>
          </TextField>

          {/* RESET */}

          <Button
            variant="outlined"
            size="small"
            className="reset-btn"
            onClick={onReset}
          >
            Reset
          </Button>
        </Box>

        {/* QUICK FILTERS */}

        <Box className="quick-filters-row">
          {[
            "today",
            "week",
            "month",
            "year",
          ].map((item) => (
            <Button
              key={item}
              size="small"
              sx={{
                mr: 1,
              }}
              className={`quick-btn ${
                quickFilter ===
                item
                  ? "active"
                  : ""
              }`}
              onClick={() =>
                handleQuickFilter(
                  item,
                )
              }
            >
              {item.charAt(0).toUpperCase() +
                item.slice(1)}
            </Button>
          ))}
        </Box>
      </Box>
    </Paper>
  );
};

export default DashboardFilter;
